import { createElement, memo, useContext } from '@max/max';
import View from '@hfe/max-view';
import VideoPlayer from "./components/VideoPlayer/index.web";
import './index.scss';
const MyComponent = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    // 调用引擎注入的自定义API
    const moduleId = ctx._moduleId;
    return <View>
      <VideoPlayer {...props}/>
    </View>;
};
export default memo(MyComponent);
